export const INITIAL_SCREEN_DATA = {
  insolvent: 'No',
  courtJudgement: 'No',
  disqualified: 'No',
  registration: 'No',
  paymentService: 'No',
  businessTypeField: ''
};

export const PERSONAL_INFO_DATA = {
  personalInformationTermsAgreement: ['Yes']
};
